import CheckMarkSuccess from "common/components/AnimatedIcons/CheckMarkSuccess/CheckMarkSuccess";
import ErrorMark from "common/components/AnimatedIcons/ErrorMark/ErrorMark";
import FormElement from "common/components/FormElement/FormElement";
import Heading from "common/components/Typography/Heading/Heading";
import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { Container,Row,Col,Form,Button } from "react-bootstrap";

import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Axios from 'services/BackendApi/BackendApi';



export default function AccessForm(props){
    const {accessTok} = useParams();
    const dispatch = useDispatch();
    const [formErrors,setFormErrors] = useState({
        access: false,
        identifier: false,
        password: false,
        repeatPassword:false
    });
    const [formData, setFormData] = useState({
        access: accessTok,
        identifier: '',
        password: '',
        repeatPassword:''
    });
    const [txData,setTxData] = useState({
        loading:false,
        finalized: false,
        result: false,
        messages: []
    })
    function onchangeInput(evc){
        let newErrors = {...formErrors};
        switch (evc.target.name){
            case "formNewPass":{
                setFormData({...formData,password:evc.target.value});
                newErrors.password = false;
            }break;
            case "formRepeatNewPass":{
                setFormData({...formData,repeatPassword:evc.target.value});
                newErrors.repeatPassword = false;
            }break;
            case "formIdentifier":{
                setFormData({...formData,identifier:evc.target.value});
                newErrors.identifier = false;
            }break;
        }
        setFormErrors(newErrors);
    }
    const submitHandler = (e) => {
        let result = null;
        e.preventDefault();
        if (validateData()){
            // aqui sign in      
            actionTx();
           
        }
            /*setErrorData({
                emailError: data.email.trim() === '',
                passwordError: data.password.trim() === '',
            });
            if (errorData.emailError || errorData.passwordError) return;
            dispatch(signin(...Object.values(data)));*/
    };
    function validateData(){
        let newErrors = {...formErrors};
        newErrors.identifier=(formData.identifier.trim()==="");
        newErrors.password = (formData.password.trim()==="");
        newErrors.repeatPassword=(formData.password!==formData.repeatPassword);
        setFormErrors(newErrors);
        return !newErrors.identifier && !newErrors.password && !newErrors.repeatPassword;
    }
    async function actionTx(){
        if (!txData.loading){
            setTxData({...txData,loading:true});
            const {data} = await Axios.ProveedorAccess(formData);
            if (data.error && data.error===true){
                setFormErrors({...formErrors,__form_general_error:data.error_log[0]});
                setTxData({loading:false,result:false,finalized:true});
            }else{
                setTxData({loading:false,result:true,finalized: true, messages: data.msg })
            }
        }
    }
    if (txData.finalized===true){
        return <div>
                <Heading variant="h2">{
                    (txData.result===true)? "Exito":"Hubo un error"
                }</Heading>
                <div>
                    {(txData.result===true)? <div>
                        <CheckMarkSuccess />
                        <div>
                            {txData.messages}
                        </div>
                    </div>:
                    <div>
                        <ErrorMark />
                        <div>
                            No se pudo completar la operación, por favor vuelva a solicitar un cambio de contraseña.
                            <br />
                            {
                                formErrors.__form_general_error && <Alert variant="danger">{formErrors.__form_general_error}</Alert>
                            }
                        </div>
                    </div>}
                </div>
                <div>
                    <Link to="/user/login">Regresar</Link>
                </div>
        </div>;
    }
    return <div>
                <Heading variant="h2">Creación de credenciales</Heading>
                    <Form onSubmit={submitHandler}>
                        {
                             formErrors.__form_general_error && <Alert variant="danger">{formErrors.__form_general_error}</Alert>
                        }
                      <FormElement 
                          margin="1" 
                          id="formIdentifier" 
                          label="Identificador" 
                          type="text" 
                          onChange={onchangeInput} 
                          name="formIdentifier" 
                          error={formErrors.identifier}     
                          errorMessage="Por favor ingrese un identificador"                     
                          placeholder="Número de proveedor o NIT"
                      />
                    <FormElement 
                          margin="1" 
                          id="formNewPass" 
                          label="Contraseña" 
                          type="password" 
                          onChange={onchangeInput} 
                          name="formNewPass" 
                          error={formErrors.password}
                          errorMessage="Contraseña no válida"
                          placeholder="Nueva contraseña"
                      />
                    <FormElement 
                          margin="1" 
                          id="formRepeatNewPass" 
                          label="Contraseña" 
                          type="password" 
                          onChange={onchangeInput} 
                          name="formRepeatNewPass" 
                          error={formErrors.repeatPassword}
                          errorMessage="Las contraseñas no coinciden"
                          placeholder="Repita su contraseña"
                      />
                       <Button variant="primary" type="submit">
                          Cambiar contraseña
                        </Button>
                    </Form>
            </div>;
}